import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_LOCATION_TYPE_CATEGORY_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateLocationTypeCategoryDetailsArgs } from '../graphql/transformers'
import { UPDATE_LOCATION_TYPE_CATEGORY_DETAILS } from '../redux/action-types'

const useUpdateLocationTypeCategoryDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.locationTypes.locationTypeCategory,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_LOCATION_TYPE_CATEGORY_DETAILS_MUTATION,
        { id, data: transformToUpdateLocationTypeCategoryDetailsArgs(data) },
        dispatch,
        UPDATE_LOCATION_TYPE_CATEGORY_DETAILS,
      ),
    [dispatch],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateLocationTypeCategoryDetailsMutation
